import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { areas } from 'src/data';

export interface NavigationState {
  cameraTransitioning: boolean;
  audioTransitioning: boolean;
  currentAreaId: string;
  currentPointId: string | null;
  soundEnabled: boolean;
  creditsOpen: boolean; // mobile only
}

const initialState: NavigationState = {
  cameraTransitioning: false,
  audioTransitioning: false,
  soundEnabled: false,
  currentAreaId: areas[areas.length - 1].sys.id,
  currentPointId: null,
  creditsOpen: false,
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    cameraTransitionStarted: (state) => {
      state.cameraTransitioning = true;
    },
    cameraTransitionCompleted: (state) => {
      state.cameraTransitioning = false;
    },
    audioTransitionStarted: (state) => {
      state.audioTransitioning = true;
    },
    audioTransitionCompleted: (state) => {
      state.audioTransitioning = false;
    },
    areaSelected: (state, action: PayloadAction<string>) => {
      if (!state.cameraTransitioning && !state.audioTransitioning) {
        state.currentAreaId = action.payload;
        state.currentPointId = null;
      }
    }, 
    pointSelected: (state, action: PayloadAction<string | null>) => {
      if (!state.cameraTransitioning && !state.audioTransitioning) {
        state.currentPointId = action.payload;
      }
    }, 
    soundEnabled: (state) => {
      state.soundEnabled = true;
    }, 
    toggleCreditsOpen: (state) => {
      state.creditsOpen = !state.creditsOpen;
    }, 
    setCreditsOpen: (state, action: PayloadAction<boolean>) => {
      state.creditsOpen = action.payload;
    }, 
  },
});

export const {
  areaSelected,
  audioTransitionCompleted,
  audioTransitionStarted,
  cameraTransitionCompleted,
  cameraTransitionStarted,
  pointSelected,
  setCreditsOpen,
  soundEnabled,
  toggleCreditsOpen,
} = navigationSlice.actions;

export const navigationReducer = navigationSlice.reducer;
